<!-- <template>
    <div>
  
      <div style="font-size: small;">
        <div class="form-check form-check-inline">
          <input type="radio" id="dailyBase" class="form-check-input" value="daily" v-model="selectedGranularity" @change="emitDataGranularity">
          <label class="form-check-label" for="dailyBase">Daily base</label>
        </div>
        <div class="form-check form-check-inline">
          <input type="radio" id="hourlyBase" class="form-check-input" value="hourly" v-model="selectedGranularity" @change="emitDataGranularity">
          <label class="form-check-label" for="hourlyBase">Hourly base</label>
        </div>
      </div>

    </div>
  </template> -->

<template>
  <div class="granularity-wrap">
    <fieldset class="segmented" :disabled="disableDataGranularity">
      <legend class="segmented-title">{{ $t('controls.granularity.title') }}</legend>

      <input
        :id="idDaily"
        :name="groupName"
        type="radio"
        class="segmented-input"
        value="daily"
        v-model="selectedGranularity"
        @change="emitDataGranularity"
        :disabled="disableDataGranularity"
      />
      <label class="segmented-btn" :for="idDaily">{{ $t('controls.granularity.daily') }}</label>

      <input
        :id="idHourly"
        :name="groupName"
        type="radio"
        class="segmented-input"
        value="hourly"
        v-model="selectedGranularity"
        @change="emitDataGranularity"
        :disabled="disableDataGranularity"
      />
      <label class="segmented-btn" :for="idHourly">{{ $t('controls.granularity.hourly') }}</label>
    </fieldset>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from 'vue'

const props = defineProps({
  dataGranularity: { type: String, default: 'daily' },
  isTableTabEventList: { type: Boolean, default: false },
  /** optional: pass your own stable prefix if you like */
  idPrefix: { type: String, default: null },
})

const emit = defineEmits(['updateDataGranularity'])

const selectedGranularity = ref(props.dataGranularity)
const disableDataGranularity = ref(props.isTableTabEventList)

watch(() => props.dataGranularity, v => (selectedGranularity.value = v), { immediate: true })
watch(() => props.isTableTabEventList, v => (disableDataGranularity.value = v), { immediate: true })

const uidBase =
  props.idPrefix ??
  `gran-${(getCurrentInstance()?.uid ?? Math.random().toString(36).slice(2))}`

const idDaily  = `${uidBase}-daily`
const idHourly = `${uidBase}-hourly`
const groupName = `${uidBase}-name`

function emitDataGranularity () {
  emit('updateDataGranularity', selectedGranularity.value)
}
</script>

<style scoped>
/* keep your segmented styles (from our earlier version) */
.granularity-wrap{ font-size:.9rem }
.segmented{ display:inline-grid; grid-auto-flow:column; border:1px solid #e6edf3; border-radius:10px; overflow:hidden; background:#fff; box-shadow:0 2px 8px rgba(13,38,76,.05) }
.segmented-title{ position:absolute; width:1px; height:1px; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); border:0; padding:0 }
.segmented-input{ position:absolute; opacity:0; pointer-events:none }
.segmented-btn{ padding:8px 14px; cursor:pointer; color:#425461; background:#fff; border-right:1px solid #e6edf3; font-weight:600; transition:background .15s,color .15s,box-shadow .15s }
.segmented-btn:last-of-type{ border-right:0 }
.segmented-btn:hover{ background:#f7fbff; color:#4F7EB3 }
.segmented-input:checked + .segmented-btn{ background:#f4f7fb; color:#2b3a44; box-shadow: inset 3px 0 0 0 #B2C149 }
.segmented-input:focus + .segmented-btn{ box-shadow:0 0 0 0.18rem #B2C14944 }
.segmented[disabled] .segmented-btn{ cursor:not-allowed; color:#9aa7b1; background:#f6f7f9 }
.segmented[disabled] .segmented-input:checked + .segmented-btn{ box-shadow: inset 3px 0 0 0 #cfd6da }
</style>